import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export type EditorialCitation = {
  label: string;
  href: string;
  publisher?: string;
  published?: string;
};

export type EditorialMeta = {
  author: string;
  reviewer: string;
  lastReviewed: string;
  citations: EditorialCitation[];
};

type Props = {
  metadata: EditorialMeta;
  title?: string;
};

export function EditorialMetaCard({ metadata, title = 'Editorial Review' }: Props) {
  return (
    <Card className="brand-frame border-border/80 bg-card/92">
      <CardHeader>
        <CardTitle className="font-display text-2xl leading-tight text-foreground">{title}</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4 pt-0 text-sm text-muted-foreground">
        <p>
          <span className="font-semibold text-foreground">Author:</span> {metadata.author}
        </p>
        <p>
          <span className="font-semibold text-foreground">Reviewed by:</span> {metadata.reviewer}
        </p>
        <p>
          <span className="font-semibold text-foreground">Last reviewed:</span> {metadata.lastReviewed}
        </p>

        {metadata.citations.length > 0 ? (
          <div className="space-y-2">
            <p className="text-xs font-semibold uppercase tracking-[0.12em] text-muted-foreground">Sources</p>
            <ul className="grid gap-2 pl-5 text-sm list-disc">
              {metadata.citations.map((citation) => (
                <li key={`${citation.href}-${citation.label}`}>
                  <a href={citation.href} target="_blank" rel="noreferrer noopener" className="text-primary underline underline-offset-2 hover:text-foreground">
                    {citation.label}
                  </a>
                  {citation.publisher ? <span> ({citation.publisher})</span> : null}
                  {citation.published ? <span> — {citation.published}</span> : null}
                </li>
              ))}
            </ul>
          </div>
        ) : null}
      </CardContent>
    </Card>
  );
}
